import React from "react";
import { Award, MapPin, FileCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trustPoints = [{
  title: "Expertise éprouvée",
  subtitle: "EXPERT RENOVATION DEPUIS 2008",
  description: "Depuis 18 ans, nous intervenons sur le terrain aux côtés des particuliers pour rénover, améliorer et valoriser leur habitat. Nous connaissons le bâti ancien avec ses singularités, ses contraintes, ses pathologies. Grâce à notre expérience en Maitrise d'Oeuvre, nos audits ne se limitent pas à un rapport : ils deviennent une véritable feuille de route réaliste, chiffrée et cohérente !",
  icon: Award
}, {
  title: "Mobilité et Réactivité",
  subtitle: "LYON & REGION AUVERGNE RHONE ALPES",
  description: "Basé sur Lyon, le rayon d'actions de nos missions s'étend à toute la région AURA. Cette connaissance étendue de notre secteur d'activité, nous en faisons bénéficier nos clients aux 4 coins de la région avec notre plus grande disponibilité et réactivité.\xA0\nEt comme votre projet est unique, nous y intégrons les valeurs qui nous sont chères : écoute et pédagogie.\xA0",
  icon: MapPin
}, {
  title: "Certification RGE",
  subtitle: "CERTIFICATION & METHODE",
  description: "L'obtention de notre certification 'Bureau d'Etudes RGE' délivrée par l'OPQiBi témoigne de l'investissement et de l'expérience que nous mettons en oeuvre dans nos missions. Cette certification vous garantit des prestations conformes aux exigences les plus strictes du secteur, réalisées par des professionnels qualifiés et régulièrement contrôlés. Elle vous permet également de bénéficier des aides financières publiques (MaPrimeRénov', CEE, éco-prêt à taux zéro).",
  icon: FileCheck
}];
export default function PourquoiNousFaireConfiance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="pourquoi-nous-faire-confiance" className="relative bg-primary overflow-hidden ![padding:60px_0px_60px_0px]">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='1'/%3E%3C/svg%3E")`
    }} />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {}
          <div className="max-w-3xl text-center ![margin:0px_360px_60px_360px]">
            <span className="inline-block px-3 py-1 rounded-full bg-accent/10 border border-accent/20 text-accent font-mono text-xs uppercase tracking-widest !m-0">Certifié Bureau d'études RGE</span>
            <h2 className="text-4xl md:text-5xl font-bold font-sans text-primary-foreground tracking-tight leading-tight">NSDB et votre projet</h2>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            {trustPoints.map((point, i) => {
            const Icon = point.icon;
            return <div key={i} data-index={i} className="group relative rounded-xl bg-white/5 border border-primary-foreground/10 transition-all duration-300 shadow-sm !p-4 hover:border-accent/30 hover:bg-white/[0.08] hover:-translate-y-1">
                  <div className="flex flex-col gap-6">
                    {}
                    <div className="size-14 rounded-lg bg-accent/10 flex items-center justify-center border border-accent/20 group-hover:scale-110 transition-transform duration-300">
                      <Icon className="text-accent size-7" strokeWidth={1.5} />
                    </div>

                    {}
                    <div className="flex flex-col gap-3">
                      <span className="text-xs font-mono text-accent uppercase tracking-wider">
                        {point.subtitle}
                      </span>
                      {i === 2 && <img src="https://nsdb.10web.cloud/wp-content/uploads/2026/03/OPQIBI_RGE.jpg?v=9vnckv7ag9r" alt="Certification RGE" className="w-[80px] h-[59px] ![margin:-70px_0px_0px_250px]" />}
                      <h3 className="text-2xl font-bold font-sans text-primary-foreground">
                        {point.title}
                      </h3>
                      <p className="text-secondary/80 leading-relaxed font-body">
                        {point.description}
                      </p>
                    </div>
                  </div>

                  {}
                  <div className="absolute top-0 right-0 w-12 h-12 overflow-hidden pointer-events-none">
                    <div className="absolute top-0 right-0 w-px h-6 bg-accent/0 group-hover:bg-accent/50 transition-colors duration-500" />
                    <div className="absolute top-0 right-0 h-px w-6 bg-accent/0 group-hover:bg-accent/50 transition-colors duration-500" />
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}